// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TRY_FORUM_PANEL__BTN = "Op\u00fdtaj sa vo f\u00f3re";
export const TRY_FORUM_PANEL__TEXT = "Nena\u0161la si odpove\u010f na svoju ot\u00e1zku?";
